<template>
  <div class="test-info row">


    <!-- Zone de titre : Affichage ou Édition -->
    <div class="col">

      <div v-if="!editTitleZone">
        <span @click="EditTitleArea(true)" v-if="!editTitleZone" class="editBTContainer">
          <font-awesome-icon :icon="['fa', 'edit']" />
        </span>

        <h2>{{ testInfo.title || "Please select a test in the Test list" }}</h2>
      </div>
      <div v-else>
        <span @click="saveAllChanges" v-if="editTitleZone" class="ValidBTContainer">
          <i class="fa fa-check" aria-hidden="true"></i>
        </span>
        <h2>
          <input type="text" v-model="editableTitle" class="edit-input" placeholder="Enter title"
            @keyup.enter="saveAllChanges" />
        </h2>
      </div>

    </div>
    <div class="col" style="text-align: right;">
      <button @click="exportTest" type="button" class="btn btn-warning btn-sm">Export Test</button>
      <button @click="closeEditor" type="button" class="btn btn-danger btn-sm ms-2">
        <i class="bi bi-x-circle"></i> Close Editor
      </button>
    </div>




    <!-- Zone de description : Affichage ou Édition -->
    <div>
      <p v-if="!editTitleZone">
        {{ testInfo.Description || "No description available" }}
      </p>
      <textarea v-else v-model="editableDescription" class="edit-textarea" placeholder="Enter description"
        @keyup.ctrl.enter="saveAllChanges"></textarea>
    </div>

    <div class="accordion" id="accordionParameters">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
            aria-expanded="true" aria-controls="collapseOne">
            <h4>Test informations</h4>
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
          data-bs-parent="#accordionParameters">
          <div class="accordion-body">
            <div class="row">
              <div class="col">
                <div hidden class="form-floating mb-3">
                  <i class="fas fa-lock locker"></i>
                  <input readonly type="text" class="form-control locked" id="testVersion"
                    :value="testInfo.version || ''">
                  <label for="testVersion">Version</label>
                </div>

                <div class="form-floating mb-3">
                  <i class="fas fa-lock locker"></i>
                  <input readonly type="text" class="form-control locked" id="testCreated"
                    :value="testInfo.metadata?.Created || ''">
                  <label for="testCreated">Created</label>
                </div>

                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="testAuthor" v-model="store.testData.metadata.Author"
                    @change="updateTestData({ metadata: testInfo.metadata })">
                  <label for="testAuthor">Author</label>
                </div>

                <div hidden class="form-floating mb-3">
                  <select id="testLanguage" class="form-select" v-model="store.testData.language">
                    <option value="en">English</option>
                    <option value="fr">French</option>
                    <option value="it">Italian</option>
                    <option value="sp">Spanish</option>
                    <option value="po">Portuguese</option>
                  </select>
                  <label for="testLanguage">Language</label>
                </div>

                <div class="form-floating mb-3">
                  <i class="fas fa-lock locker"></i>
                  <input readonly type="text" class="form-control locked" id="testPages"
                    :value="testInfo.pages?.length || 0">
                  <label for="testPages">Pages </label>
                </div>
                <div class="form-floating mb-3">
                  <select id="Tpath" class="form-select" v-model="store.testData.progression"
                    @change="updateTestData({ progression: testInfo.progression })" title="Test Path"
                    aria-label="progression">
                    <option value="linear">Linear</option>
                    <option disabled value="conditional">Conditional</option>
                    <option disabled value="chosen">Chosen</option>
                    <option value="adaptive">Adaptive (CAT)</option>
                  </select>
                  <label for="Tpath">Test Progression</label>
                </div>

                <!-- Configuration CAT si mode adaptatif sélectionné -->
                <div v-if="testInfo.progression === 'adaptive'" class="col-12 mt-3">
                  <CATNbQuestionsSimulator
                    :model-value="testInfo.CATParameters || { paliers: 4, confirmation: 3, echec: 3, randomizedItemOrder: true }"
                    :show-rebuild-button="true" @update:model-value="updateCATParameters"
                    @items-distributed="handleItemsDistributed" @cat-rebuilt="handleCATRebuilt" />
                </div>
              </div>
              <div class="col">
                <div class="mb-3">
                  <IscedSelector v-model="store.testData.ISCED" @change="updateTestData({ ISCED: testInfo.ISCED })" />
                </div>

                <div hidden class="form-floating mb-3">
                  <select class="form-select" id="stagesOfEducation" v-model="store.testData.level"
                    @change="updateTestData({ level: testInfo.level })" aria-label="Floating label select example">
                    <option value="KS2">KS2</option>
                    <option value="KS3">KS3</option>
                    <option value="KS4">KS4</option>
                    <option value="A-Levels">A-Levels</option>
                    <option value="BTECs">BTECs</option>
                    <option value="Undergraduate">Undergraduate</option>
                    <option value="Postgraduate">Postgraduate</option>
                  </select>
                  <label for="stagesOfEducation">Education Key level</label>
                </div>
                <div class="mb-3">
                  <SubjectSelector v-model="store.testData.Subject"
                    @update:model-value="updateTestData({ Subject: $event })" />
                </div>

                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="testDomain" v-model="store.testData.domain"
                    @change="updateTestData({ domain: testInfo.domain })">
                  <label for="testDomain">Domain</label>
                </div>

                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="testKeywords" v-model="store.testData.Keywords"
                    @change="updateTestData({ Keywords: testInfo.Keywords })">
                  <label for="testKeywords">Keywords</label>
                </div>
              </div>
              <div class="col">

                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="testDuration" v-model="store.testData.duration"
                    @change="updateTestData({ duration: store.testData.duration })">
                  <label for="testDuration">Duration</label>
                </div>
              </div>
              <div class="dimension mt-3">
                <DimensionManager v-model:dimensions="store.testData.dimensions" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useTestStore } from "../stores/testStore";
import { useEventBus } from '@vueuse/core';
import IscedSelector from "./common/IscedSelector.vue";
import SubjectSelector from "./common/SubjectSelector.vue";
import DimensionManager from "./DimensionManager.vue";
import CATNbQuestionsSimulator from "./CAT/CATNbQuestionsSimulator.vue";

// Event bus pour communiquer avec d'autres composants
const testUpdateBus = useEventBus('test-updated');

// Définir l'émission d'événements
const emit = defineEmits(['close-editor']);

const DEFAULT_SETTINGS = {
  timeLimit: false,
  shuffleQuestions: true,
  shufflePages: true,
  NavigationPanel: false,
  progressBar: true,
  feedbackAllowed: true,
  directScore_FB: true,
  countDown: true,
  skip: true
};

const DEFAULT_TEST_INFO = {
  title: "",
  Description: "",
  version: "",
  language: "en",
  navigation: "Browing back is possible",
  progression: "Linear",
  CATParameters: {
    paliers: 4,
    confirmation: 3,
    echec: 3,
    calculatedItems: 0,
    randomizedItemOrder: true
  },
  metadata: {
    Created: "",
    Author: "",
  },
  pages: [],
  Keywords: [],
  settings: DEFAULT_SETTINGS
};

const store = useTestStore();
const testData = store.testData;

const testInfo = computed(() => {
  const storeData = store.testData || {};
  // Créer une copie profonde des données par défaut
  const mergedData = {
    ...DEFAULT_TEST_INFO,
    ...storeData,
    // Fusionner explicitement les objets imbriqués
    metadata: {
      ...DEFAULT_TEST_INFO.metadata,
      ...(storeData.metadata || {}),
      Author: storeData.metadata?.Author || DEFAULT_TEST_INFO.metadata.Author
    },
    settings: {
      ...DEFAULT_SETTINGS,
      ...(storeData.settings || {})
    },
    CATParameters: {
      ...DEFAULT_TEST_INFO.CATParameters,
      ...(storeData.CATParameters || {})
    }
  };
  return mergedData;
});


// Variables d'édition
var editTitleZone = ref(false);
const editableTitle = ref('');
const editableDescription = ref('');

const EditTitleArea = (state) => {
  editTitleZone.value = state;
  if (state) {
    // Initialiser les valeurs éditables quand on entre en mode édition
    editableTitle.value = testInfo.value.title || '';
    editableDescription.value = testInfo.value.Description || '';
  }
};

// Fonction de sauvegarde globale (titre + description)
const saveAllChanges = async () => {
  console.log('💾 Saving all changes...');
  console.log('Current title:', testInfo.value.title, '→ New title:', editableTitle.value);
  console.log('Current description:', testInfo.value.Description, '→ New description:', editableDescription.value);

  let hasChanges = false;
  const changes = {};

  // Vérifier les changements de titre
  if (editableTitle.value !== testInfo.value.title) {
    changes.title = editableTitle.value;
    hasChanges = true;
    console.log('📝 Title changed');
  }

  // Vérifier les changements de description
  if (editableDescription.value !== testInfo.value.Description) {
    changes.Description = editableDescription.value;
    hasChanges = true;
    console.log('📝 Description changed');
  }

  if (hasChanges) {
    try {
      console.log('💾 Applying changes:', changes);
      await updateTestData(changes);

      // Émettre un événement pour notifier d'autres composants (comme le Tabulator)
      const eventData = {
        type: 'title-description-updated',
        testId: testInfo.value._id || testInfo.value.ID,
        changes: changes
      };

      console.log('📡 Emitting test update event:', eventData);
      testUpdateBus.emit('refresh-tests', eventData);

      console.log('✅ All changes saved and event emitted');
    } catch (error) {
      console.error('❌ Error saving changes:', error);
      alert('Erreur lors de la sauvegarde. Veuillez réessayer.');
      return; // Ne pas fermer l'édition en cas d'erreur
    }
  } else {
    console.log('ℹ️ No changes detected');
  }

  // Fermer le mode édition
  EditTitleArea(false);
};

// Fonctions de sauvegarde spécifiques (conservées pour compatibilité)
const saveTitle = async () => {
  await saveAllChanges();
};

const saveDescription = async () => {
  await saveAllChanges();
};

// Flag pour éviter les mises à jour pendant le chargement initial
const isInitialLoad = ref(true);

const updateTestData = async (data) => {
  // Éviter les mises à jour automatiques pendant le chargement initial, SAUF pour les sauvegardes manuelles
  const isManualSave = data.title || data.Description || data.Subject || data.domain || data.Keywords || data.duration || data.ISCED;
  if (isInitialLoad.value && !isManualSave) {
    console.log("🔄 updateTestData ignoré (chargement initial):", data);
    return;
  }

  if (isManualSave) {
    console.log("✅ updateTestData - sauvegarde manuelle autorisée:", data);
  }

  console.log("✅ updateTestData appelé:", data);
  const updateData = {
    ...data,
    metadata: {
      ...testInfo.value.metadata,
      ...data.metadata,
      LastModif: new Date().toISOString() // Ajout sécurisé
    }
  };

  try {
    await store.updateTestData(updateData); // Met à jour le store et déclenche la sauvegarde
    console.log("✅ Test data updated successfully");

    // Émettre un événement pour notifier d'autres composants (comme TestList)
    if (data.Subject) {
      const eventData = {
        type: 'subject-updated',
        testId: testInfo.value._id || testInfo.value.ID,
        changes: { Subject: data.Subject }
      };

      console.log('📡 Emitting subject update event:', eventData);
      testUpdateBus.emit('refresh-tests', eventData);
    }

  } catch (error) {
    console.error("❌ Error updating test data:", error);
    throw error;
  }
};

const updateCATParameters = (catParams) => {
  // Même protection que updateTestData
  if (isInitialLoad.value) {
    console.log("🔄 updateCATParameters ignoré (chargement initial):", catParams);
    return;
  }

  console.log("✅ updateCATParameters appelé:", catParams);
  updateTestData({ CATParameters: catParams });
};

const handleItemsDistributed = (distributionData) => {
  console.log("🎯 Items distributed from CAT search:", distributionData);

  // Sauvegarder les données de distribution CAT dans le test
  const catDistribution = {
    items: distributionData.items,
    calibrationMethod: distributionData.calibrationMethod,
    totalItems: distributionData.totalItems,
    distribution: distributionData.distribution,
    searchCriteria: distributionData.searchCriteria,
    lastUpdated: new Date().toISOString()
  };

  updateTestData({
    CATDistribution: catDistribution,
    CATParameters: {
      ...testInfo.value.CATParameters,
      itemsDistributed: true,
      lastDistribution: new Date().toISOString()
    }
  });

  // Notification pour l'utilisateur
  console.log("✅ CAT items successfully saved to test data");

  // Optionnel: rediriger vers l'onglet CAT Editor
  // Cette partie pourrait être implémentée plus tard si nécessaire
};

const handleCATRebuilt = (rebuildData) => {
  console.log("🔧 CAT Test rebuilt:", rebuildData);

  // Afficher un message de confirmation immédiat
  alert(`✅ Test CAT reconstruit avec succès !
  
📊 Résultats:
- ${rebuildData.elementsCreated || 0} éléments créés
- ${rebuildData.catItemsSynced || 0} items synchronisés dans CAT
- ${rebuildData.levelsCreated || 0} niveaux créés
- Structure CAT mise à jour

Le test est maintenant prêt pour l'édition CAT.
Rechargez la page pour voir les modifications.`);

  console.log("✅ CAT rebuild completed successfully");
};

let isUpdating = false;

// Watcher pour réactiver les mises à jour après chargement initial
watch(() => store.testData?.ID, (newID, oldID) => {
  // À chaque changement de test, réinitialiser le flag
  isInitialLoad.value = true;
  console.log("🔄 Nouveau test détecté, protection activée:", store.testData?.title);

  if (newID) {
    // Délai pour permettre au template de se stabiliser
    setTimeout(() => {
      isInitialLoad.value = false;
      console.log("🟢 Mises à jour réactivées pour:", store.testData?.title);
    }, 200); // Délai plus long pour laisser le temps au CATNbQuestionsSimulator de se monter
  }
});

// WATCHER TEMPORAIREMENT DÉSACTIVÉ POUR DEBUG
/*
watch(
  () => ({ ...testInfo.value }), // Clone pour éviter de modifier directement l'objet
  (newVal, oldVal) => {
    if (isUpdating) return;
    if (!oldVal) return; // Éviter l'exécution au premier rendu
    isUpdating = true;

    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      store.updateTestData({ ...newVal }); // Mise à jour du store
    }

    setTimeout(() => { isUpdating = false; }, 100); // Petit délai pour éviter les boucles rapides
  },
  { deep: true, immediate: false } // Désactiver immediate pour éviter les boucles
);
*/


// Fonction pour fermer l'éditeur
const closeEditor = () => {
  emit('close-editor');
};

// Fonction pour exporter le test
const exportTest = () => {
  try {
    // On accède directement aux données via testInfo.value ou store.testData
    const sourceData = store.testData || testInfo.value;

    const test = {
      ID: sourceData.ID,
      title: sourceData.title,
      type: sourceData.type,
      version: sourceData.version,
      language: sourceData.language,
      navigation: sourceData.navigation,
      progression: sourceData.progression,
      Description: sourceData.Description,
      submission: sourceData.submission,
      preset: sourceData.preset,
      Subject: sourceData.Subject,
      location: sourceData.location,
      level: sourceData.level,
      ISCED: sourceData.ISCED,
      domain: sourceData.domain,
      duration: sourceData.duration,
      Keywords: sourceData.Keywords,
      metadata: sourceData.metadata,
      pages: sourceData.pages || [],
      elements: sourceData.elements || [],
      settings: sourceData.settings,

      // Champs pour les dimensions psychométriques (tous types de tests)
      dimensions: sourceData.dimensions || [],

      // Champs spécifiques aux tests adaptatifs (CAT)
      ...(sourceData.progression === 'adaptive' && {
        CATDistribution: sourceData.CATDistribution || {},
        CATParameters: sourceData.CATParameters || {}
      }),

      // Champs spécifiques aux tests conditionnels
      ...(sourceData.progression === 'conditional' && sourceData.ConditionalStructure && {
        ConditionalStructure: {
          nodes: sourceData.ConditionalStructure.nodes || [],
          edges: sourceData.ConditionalStructure.edges || [],
          settings: sourceData.ConditionalStructure.settings || {}
        }
      })
    };

    // Générer le JSON avec une indentation de 2 espaces
    const jsonContent = JSON.stringify(test, null, 2);

    // Créer un fichier téléchargeable
    const blob = new Blob([jsonContent], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);

    // Créer un nom de fichier valide avec indication du type de progression
    const timestamp = new Date().toISOString().split('T')[0];
    const safeName = test.title ? test.title.replace(/[^a-z0-9]/gi, '_').toLowerCase() : 'test';
    const progressionSuffix = test.progression ? `_${test.progression}` : '';
    link.download = `${safeName}${progressionSuffix}_${timestamp}.json`;

    // Déclencher le téléchargement
    link.click();

    // Nettoyer l'URL temporaire
    URL.revokeObjectURL(link.href);

    // Log détaillé pour diagnostic
    console.log('✅ Export réussi !', {
      title: test.title,
      progression: test.progression,
      elementsCount: test.elements?.length || 0,
      dimensionsCount: test.dimensions?.length || 0,
      hasCAT: !!test.CATDistribution,
      hasConditional: !!test.ConditionalStructure,
      CATItemsCount: test.CATDistribution?.items?.length || 0,
      ConditionalNodesCount: test.ConditionalStructure?.nodes?.length || 0
    });
  } catch (error) {
    console.error("❌ Erreur lors de l'exportation :", error);
    alert(`Erreur lors de l'exportation du test: ${error.message}`);
  }
};


</script>

<style scoped>
.edit-icon {
  font-size: 1.6em;
  cursor: pointer;
  color: #007bff;
  transition: color 0.3s;
}

.edit-icon:hover {
  color: #0056b3;
}

.editBTContainer {
  color: #007bff;
  cursor: pointer;
  float: left;
  font-size: 1em;
  margin-right: 10px;
}

.ValidBTContainer {
  background-color: lightgreen;
  margin-top: 5px;
  border: 3px solid green;
  border-radius: 5px;
  padding-left: 3px;
  padding-right: 3px;
  margin-right: 12px;
  color: green;
  cursor: pointer;
  float: left;
  font-size: 0.5em;
}

.accordion-button {
  background-color: rgb(233, 243, 248);
}

.testEditorBTContainer {
  text-align: right;
}


.locked {
  background-color: #f8f9fa;
}

.locker {
  color: lightgrey;
  position: absolute;
  width: 100%;
  text-align: right;
  margin-left: -10px;
  margin-top: 5px;
}

.TestReport {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  margin-top: 20px;
  border: 1px solid #ccc;
}

h2 {
  font-size: 1.5rem;
  color: #1565C0
}

.edit-input {
  font-style: italic;
  color: grey;
  margin-top: 5px;
  padding: 5px;
  border: 1px grey solid;
  border-radius: 10px;
}

.edit-textarea {
  font-style: italic;
  color: grey;
  width: 100%;
  border-radius: 5px;
  border: 1px grey solid;
  padding: 5px;
}
</style>